"use client";

import { useState } from "react";
import { Play } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
function VideoGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  const [selectedVideo, setSelectedVideo] = useState<{
    title: string;
    url: string;
  } | null>(null);
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="aspect-video rounded-lg bg-muted/30 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-sm text-white">
        Failed to load videos.
      </div>;
  }
  return <>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {posts.map((post, i) => {
        const thumbnailUrl = post.customFields?.thumbnail || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/video_placeholder.png";
        const videoUrl = post.customFields?.url || "";
        return <Button key={post.id} data-index={i} onClick={() => setSelectedVideo({
          title: post.title,
          url: videoUrl
        })} className="group relative aspect-video overflow-hidden rounded-lg border border-border bg-muted-dark-background transition-all duration-[80ms] hover:scale-[1.02] hover:shadow-[0_0_20px_rgba(0,255,255,0.3)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring h-auto p-0" variant="ghost">
              <img src={thumbnailUrl} alt={post.title} className="h-full w-full object-cover" />
              <div className="absolute inset-0 flex items-center justify-center bg-black/40 transition-opacity group-hover:bg-black/50">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-accent text-accent-dark shadow-medium transition-transform group-hover:scale-110">
                  <Play className="h-8 w-8 fill-current" />
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
                <h3 className="text-left text-sm font-semibold text-white">
                  {post.title}
                </h3>
              </div>
            </Button>;
      })}
      </div>

      <Dialog open={selectedVideo !== null} onOpenChange={open => !open && setSelectedVideo(null)}>
        <DialogContent className="max-w-4xl animate-in fade-in-0 slide-in-from-top-4 duration-200">
          <DialogHeader>
            <DialogTitle>{selectedVideo?.title}</DialogTitle>
          </DialogHeader>
          {selectedVideo?.url && <div className="aspect-video w-full overflow-hidden rounded-md">
              <iframe src={selectedVideo.url} title={selectedVideo.title} className="h-full w-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
            </div>}
        </DialogContent>
      </Dialog>
    </>;
}
export default function CompanyVideos() {
  return;
}